import "core-js/modules/es6.object.assign";
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import { d as _inheritsLoose, a as _extends } from './chunk-79dadc73.js';
import { createElement, Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import { string, func, number } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import 'react-dom';
import './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import './chunk-27cf4a5a.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-23007274.js';
import { a as StepContainer, b as StepNext, c as StepPrevious } from './chunk-e32febcf.js';

var StepComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(StepComponent, _React$Component);

  function StepComponent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var _this$props = _this.props,
        register = _this$props.register,
        step = _this$props.step,
        order = _this$props.order;
    register(step, order);
    return _this;
  }

  var _proto = StepComponent.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        step = _this$props2.step,
        update = _this$props2.update,
        order = _this$props2.order;

    if (prevProps.step !== step || prevProps.order !== order) {
      update(prevProps.step, step, order);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$props3 = this.props,
        step = _this$props3.step,
        unregister = _this$props3.unregister;
    unregister(step);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        isCurrent = _this$props4.isCurrent,
        step = _this$props4.step;
    return createElement(Hidden, _extends({
      unmount: true,
      visible: isCurrent(step)
    }, this.props));
  };

  return StepComponent;
}(Component);

hoistNonReactStatics(StepComponent, Hidden);
var Step = styled(StepComponent).withConfig({
  displayName: "Step",
  componentId: "sc-1b10ris-0"
})(["", ";"], theme("Step")); // @ts-ignore

Step.propTypes = {
  step: string.isRequired,
  register: func.isRequired,
  update: func.isRequired,
  unregister: func.isRequired,
  isCurrent: func.isRequired,
  order: number
};
var Step$1 = as("div")(Step);

var toggle = function toggle(props) {
  return function () {
    return props.toggle && props.toggle(props.step);
  };
};

var Component$1 = function Component$$1(props) {
  return createElement(HiddenToggle, _extends({}, props, {
    toggle: toggle(props)
  }));
};

var StepToggle = styled(Component$1).withConfig({
  displayName: "StepToggle",
  componentId: "sc-73h2vf-0"
})(["", ";"], theme("StepToggle")); // @ts-ignore

StepToggle.propTypes = {
  toggle: func.isRequired,
  step: string.isRequired
};
var StepToggle$1 = as("button")(StepToggle);

var show = function show(props) {
  return function () {
    return props.show && props.show(props.step);
  };
};

var Component$2 = function Component$$1(props) {
  return createElement(HiddenShow, _extends({}, props, {
    show: show(props)
  }));
};

var StepShow = styled(Component$2).withConfig({
  displayName: "StepShow",
  componentId: "rrfdz6-0"
})(["", ";"], theme("StepShow")); // @ts-ignore

StepShow.propTypes = {
  show: func.isRequired,
  step: string.isRequired
};
var StepShow$1 = as("button")(StepShow);
var StepHide = styled(HiddenHide).withConfig({
  displayName: "StepHide",
  componentId: "sc-1uq7y3z-0"
})(["", ";"], theme("StepHide"));
var StepHide$1 = as("button")(StepHide);
var Step$2 = Object.assign(Step$1, {
  Container: StepContainer,
  Toggle: StepToggle$1,
  Show: StepShow$1,
  Hide: StepHide$1,
  Next: StepNext,
  Previous: StepPrevious
});
export default Step$2;